import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { BadImplementationException, resolveContent } from '@nu-art/ts-common';
const ShowIf = (props) => {
    return _jsx(_Fragment, { children: props.children });
};
const ShowElse = (props) => {
    return _jsx(_Fragment, { children: props.children });
};
export const Show = (props) => {
    const toRender = [];
    let elseRender;
    React.Children.forEach(props.children, (child) => {
        if (!React.isValidElement(child) || ![ShowIf, ShowElse].includes(child.type))
            throw new BadImplementationException('Children of Show component must be Show.If or Show.Else');
        if (child.type === ShowElse) {
            if (elseRender)
                throw new BadImplementationException('Show must have only 1 Show.Else child');
            return elseRender = child;
        }
        if (!resolveContent(child.props.condition))
            return;
        toRender.push(child);
    });
    if (toRender.length)
        return _jsxs(_Fragment, { children: [...toRender] });
    return elseRender ?? _jsx(_Fragment, {});
};
Show.If = ShowIf;
Show.Else = ShowElse;
//# sourceMappingURL=Show.js.map